import { Pipe, PipeTransform } from '@angular/core';
import { SupportedTimezone } from '@shared/datetime/datetime.utils';
import dayjs from 'dayjs';

@Pipe({
  standalone: true,
  name: 'translateTimezone',
})
export class TranslateTimezonePipe implements PipeTransform {
  public transform(value: SupportedTimezone): string {
    const name = getTimezoneName(value);
    const offset = dayjs().tz(value).format('Z');

    return `${name} (${offset})`;
  }
}

function getTimezoneName(value: SupportedTimezone): string {
  switch (value) {
    case 'America/New_York':
      return 'EST';
    case 'Canada/Mountain':
      return 'Mountain';
    case 'US/Central':
      return 'Central';
    case 'PST8PDT':
      return 'PST';
    default:
      return value;
  }
}

// undefined as EST (temp solution until backend change the name for America/New_York)
export function toApiTimezone(value?: SupportedTimezone) {
  return value === 'America/New_York' ? undefined : value;
}
